import { CreditNoteWithLineItemsSchema, } from '@packages/types';
import { api, apiRaw, filenameFromResponse } from '../client.js';
export function createCreditNote(accountId, invoiceId, input) {
    return api(`/accounts/${accountId}/invoices/${invoiceId}/credit-notes`, CreditNoteWithLineItemsSchema, { method: 'POST', body: input });
}
export function listCreditNotesForInvoice(accountId, invoiceId) {
    return api(`/accounts/${accountId}/invoices/${invoiceId}/credit-notes`, CreditNoteWithLineItemsSchema.array());
}
export function getCreditNote(accountId, creditNoteId) {
    return api(`/accounts/${accountId}/credit-notes/${creditNoteId}`, CreditNoteWithLineItemsSchema);
}
export async function downloadCreditNotePdf(accountId, creditNoteId) {
    const response = await apiRaw(`/accounts/${accountId}/credit-notes/${creditNoteId}/pdf`);
    const filename = filenameFromResponse(response, 'credit-note.pdf');
    const blob = await response.blob();
    return { blob, filename };
}
